/**
 * Responsible for common URL manipulations
 */
/**
 * Given a URL string, replace the subdomain (if any) with the subdomain given. This assumes
 * that subdomains are at _most_ one layer deep, so if you have foo.bar.doxy.me, it will
 * replace foo.bar. rather than just foo.
 * @param {string} url - A full URL i.e. https://doxy.me
 * @param {string} subdomain - The subdomain to prepend on this href
 * @returns {string} url
 */
export function replaceSubdomain(url, subdomain) {
    const parsedUrl = new URL(url);
    const parts = parsedUrl.hostname.split('.');
    parsedUrl.hostname = `${subdomain}.${parts.slice(-2).join('.')}`;
    if (parsedUrl.pathname === '/') {
        // Remove the trailing slash if there is no pathname
        return parsedUrl.toString().slice(0, -1);
    }
    return parsedUrl.toString();
}
/**
 * Given a URL as a string, set i.e. add or replace the query parameter on
 * the URL
 * @param url
 * @param key
 * @param value
 */
export function setQueryParameter(url, key, value) {
    const parsed = new URL(url);
    parsed.searchParams.set(key, value);
    return parsed.toString();
}
